module.exports = __webpack_public_path__ + "assets/img/nh6.02382565.jpg";